import {handleNewRollout} from './handle-new-rollout.js'
import {sendPresetRolloutModelToServer} from '../connection/firebase.js'
import {trackHpOfTeams} from '../analysis/track-hp-of-teams.js'
import store from '../../init/store.js'
import {getDeadTeams} from './get-dead-teams'
import {writeTrackingReportToDatabase} from '../analysis/write-tracking-report-to-database.js'
import {getColoredNameById} from '../../helpers/rollout-message-text-helpers.js'


export function submitBattleOver() {


  //TODO: this block is totally a bandaid. This is getting called when the ID is already "rollout_battle-over"
  //TODO: Need to look closer when more focused and less beered
  //TODO: UPDATE It might not be that much of a bandaid. It might happen every time? not sure.
  if (store.getState().battle.rolloutId === "rollout_battle-over") {
    //console.log('stopping battle because rolloutId is `rollout_battle-over`');
    return;
  }

  //TRACKING ///////////
  trackHpOfTeams(); //Include final HP count for tracking (does not affect anything in Battle)
  //Future self: this simply records the last HP count in the tracking array. This report may be phased out as we adopt `turnReporting`


  writeTrackingReportToDatabase(); //side effect
  ////////////////////




  //Figure out if Player team won or lost/////////////
  //Get the player model
  const playerModel = store.getState().battle.combatants[
    store.getState().battle.battlePlayerId[0]
  ] || {name:"REPORTING-MODE", belongsToTeam: "none"}; //provide fallback in case there is no player (Reporting mode, all bots, etc)

  //Check dead teams array for the player's team
  const didPlayerLose = Boolean( getDeadTeams().find(teamId => teamId === playerModel.belongsToTeam) );

  //This is the same functionality that submitAction does, but without all the generation of payload
  //Create the rollout steps for end of battle
  const endingRolloutSteps = [
    {
      type: "message",
      content: [
        getColoredNameById(playerModel.id), //use colored name
        didPlayerLose
          ? `'s team has been defeated!`
          : `'s team is victorious!`
      ]
    }
  ];

  if (store.getState().battle.isMultiplayerMode) {
    //Note: Only 1 client does this. Whichever client processed the state.

    // console.log('submitting ending to the server')
    //Online needs to do sendRolloutStepsToServer just like `submitAction`
    //sendRolloutStepsToServer(endingRolloutSteps);
    //TODO: you should create an alternate server function to replace this guy that does the WHOLE rollout. Just like the client one does.
    //Currently, `sendRolloutStepsToServer` does some random ID generation and stuff. You can just provide the whole model

    sendPresetRolloutModelToServer({
      submitterCombatantId: "BATTLE-SYSTEM",
      rolloutId: "rollout_battle-over",
      rolloutPayload: endingRolloutSteps
    })

  } else {

    //Offline:
    const endingRollout = {
      submitterCombatantId: "BATTLE-SYSTEM",
      rolloutId: "rollout_battle-over",
      timestamp: Date.now(),
      rolloutPayload: endingRolloutSteps
    };

    console.warn('battle over');
    //console.warn('sending of `battle-over` rollout is temporarily disabled. see TODO')
    handleNewRollout(endingRollout); //TODO: submit battle-over in a way that doesn't cause replay
                                        //It's causing an infinite loop right now because handleRolloutStep doesn't know to stop?

  }

}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/submit-battle-over.js